import { Header } from "./NavBarStyles";

import Links from "./Links";
import SocialMedia from "./SocialMedia";
import SocialMediaBlue from "./SocialMediaDropdown";

import BurgerMenu from "./BurgerMenu";
import MenuDropdown from "../generalComponents/MenuDropdown";

import useDropdown from "../hooks/useDropdown";

const NavBar = () => {
  const { openmenu, ref, onClickDropDown } = useDropdown();

  return (
    <Header >
      <div className="header__Links hide">
        <Links />
      </div>
      <div className="header__SocialMedia hide">
        <SocialMedia />
      </div>
      <div ref={ref} className="header__burgermenu">
        <BurgerMenu onclick={onClickDropDown} />

        {openmenu && (
          <MenuDropdown>
            <Links />
            <SocialMediaBlue />
          </MenuDropdown>
        )}
      </div>
    </Header>
  );
};

export default NavBar;
